import React, { useContext } from 'react';
import { Grid, Box, Paper, Typography } from '@mui/material';

import VendorItemHeader from './VendorItemHeader';
import VendorItemOptions from './VendorItemOptions';
import SellScreen from '../../Salgs/SellScreen/SellScreen';
import PaymentScreen from '../../Salgs/PaymentScreen/PaymentScreen';
import PapirScreen from '../../Salgs/PapirScreen/PapirScreen';
import PapirScreenKingo from '../../Salgs/PapirScreenKingo/PapirScreenKingo';

import { AppContext } from '../../../context/Context';
import useDb from '../../../data/db';

import English from '../../../assets/img/english.png';
import Norsk from '../../../assets/img/norsk.png';
import { useTranslation } from 'react-i18next';

import ReceiptIcon from '@mui/icons-material/Receipt';
import NfcIcon from '@mui/icons-material/Nfc';

function Vendors() {
  const {
    isSellerOpen,
    isPapirOpen,
    isPaymentOpen,
    isOcrOpen,
    isPapirKingoOpen,
    providerIndex,
    enviroment,
    isNTEnabled,
    isKioskEnabled,
  } = useContext(AppContext);
  const { t, i18n } = useTranslation();

  const db = useDb();

  return (
    <>
      <>
        <Grid
          item
          xs={12}
          sx={{
            height: '100%',
            width: '100%',
            p: 2,
          }}
        >
          <Box
            sx={{
              height: '100%',
              width: '100%',
              borderRadius: '15px',
              display: 'flex',
              flexDirection: 'column',
            }}
          >
            {/* LANGUAGE MENU */}
            <Box
              sx={{
                px: 2,
                pt: 1,
                pb: 1,
                display: 'flex',
                justifyContent: 'flex-start',
                alignItems: 'center',
              }}
            >
              <Grid
                container
                direction="row"
                spacing={1.5}
                sx={{ maxWidth: 180, gap: 3 }}
                justifyContent="flex-start"
                alignItems="center"
              >
                <Grid
                  item
                  sx={{
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                  }}
                >
                  <Box
                    component="img"
                    sx={{
                      width: 30,
                      height: 'auto',
                      cursor: 'pointer',
                    }}
                    alt=""
                    src={Norsk}
                    onClick={() => {
                      i18n.changeLanguage('no');
                      localStorage.setItem('language', 'no');
                    }}
                  />
                </Grid>

                <Grid
                  item
                  sx={{
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                  }}
                >
                  <Box
                    component="img"
                    sx={{
                      width: 30,
                      height: 'auto',
                      cursor: 'pointer',
                    }}
                    alt=""
                    src={English}
                    onClick={() => {
                      i18n.changeLanguage('en');
                      localStorage.setItem('language', 'en');
                    }}
                  />
                </Grid>
              </Grid>
            </Box>

            {/* VENDORS LIST (takes remaining height, scrollable) */}
            <Box
              sx={{
                flex: 1,
                overflowY: 'auto',
                px: 2,
                pb: 2,
                pt: 1,
              }}
              className="hide-scrollbar"
            >
              <Grid
                container
                flexDirection="row"
                spacing={1.5}
                sx={{
                  width: '100%',
                  m: 0,
                }}
              >
                {db[0].vendors.map((vendor, index) => {
                  if (
                    index > providerIndex * 6 - 1 ||
                    index < providerIndex * 6 - 6 ||
                    (vendor.name === 'EBS' && enviroment === 'prod')
                  ) {
                    return null;
                  }

                  if (vendor.name === 'Norsk Tipping') return null;
                  if (vendor.name === 'Kiosk') return null;

                  return (
                    <Grid item xs={12} key={index}>
                      <Paper
                        elevation={6}
                        sx={{
                          bgcolor: '#121212',
                          borderRadius: '15px',
                          p: 2.5,
                          display: 'flex',
                          flexDirection: 'column',
                          gap: 1,
                          mt: 1,
                          mb: 1,
                        }}
                      >
                        <VendorItemHeader vendor={vendor} />
                        <VendorItemOptions vendor={vendor} />
                      </Paper>
                    </Grid>
                  );
                })}
              </Grid>
            </Box>

            {/* EXTRA INFO / SCAN BOX (stays at bottom, centered) */}
            <Box
              sx={{
                pt: 1,
                pb: 2,
                display: 'flex',
                justifyContent: 'center',
              }}
            >
              <Box
                sx={{
                  background: 'rgba(15, 19, 32, 0.85)',
                  border: '1px solid rgba(111, 130, 255, 0.6)',
                  borderRadius: 9999,
                  px: 4,
                  py: 1.5,
                  display: 'flex',
                  gap: 1.5,
                  alignItems: 'center',
                  boxShadow: '0 10px 35px rgba(0,0,0,0.35)',
                  backdropFilter: 'blur(4px)',
                  animation: 'pulse 2.5s ease-in-out infinite',
                  '@keyframes pulse': {
                    '0%': { boxShadow: '0 0 0 rgba(111,130,255,0.4)' },
                    '50%': { boxShadow: '0 0 25px rgba(111,130,255,0.7)' },
                    '100%': { boxShadow: '0 0 0 rgba(111,130,255,0.4)' },
                  },
                }}
              >
                <ReceiptIcon sx={{ color: '#6f82ff', fontSize: 30 }} />
                <Typography
                  sx={{ color: 'white', fontSize: 18, whiteSpace: 'nowrap' }}
                >
                  {t('login.ticket')}
                </Typography>
              </Box>
            </Box>
          </Box>
        </Grid>
      </>

      {isSellerOpen && !isPapirOpen && !isPapirKingoOpen && (
        <Grid
          container
          flexDirection="row"
          sx={{
            height: '100%',
            width: '100%',
            marginTop: 0,
            marginLeft: 0,
          }}
        >
          <SellScreen />
        </Grid>
      )}
      {isSellerOpen && isPapirOpen && (
        <Grid
          container
          flexDirection="row"
          sx={{
            height: '100%',
            width: '100%',
            marginTop: 0,
            marginLeft: 0,
          }}
        >
          <PapirScreen />
        </Grid>
      )}
      {isSellerOpen && isPapirKingoOpen && (
        <Grid
          container
          flexDirection="row"
          sx={{
            height: '100%',
            width: '100%',
            marginTop: 0,
            marginLeft: 0,
          }}
        >
          <PapirScreenKingo />
        </Grid>
      )}
      {isPaymentOpen && (
        <Grid
          container
          flexDirection="row"
          sx={{
            height: '100%',
            width: '100%',
            marginTop: 0,
            marginLeft: 0,
          }}
        >
          <PaymentScreen />
        </Grid>
      )}
    </>
  );
}

export default Vendors;
